module.exports = __webpack_public_path__ + "img/merchant-page-graphic2@4x.cb9c986b.png";